import '../LibraryBoxBattle.scss'
import NP from "../../../1. Core/NP";
import Control from "../../../1. Core/Control";
import ListGroupHeader from "../../../1. Core/Controls/ListBox/ListGroupHeader";
import Delegate from "../../../1. Core/Delegate";
import IconSelect from "../../../1. Core/Controls/Select/IconSelect";
import {getStages, getTournaments, getWeights, getWeightString, ITournament, Weight} from "../../Util";
import Select from "../../../1. Core/Controls/Select/Select";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import {EventTournament, SportType} from "../../types";
import CheckBox from "../../../1. Core/Controls/CheckBox/CheckBox";


export default class AthletesFilterPanel extends Control {

	public EvFilterSortChanged: Delegate;

	private _tournamentCombo: IconSelect;
	private _eventCombo: IconSelect;
	private _genderCombo: IconSelect;
	private _weightCombo: IconSelect;
	private _stageCombo: IconSelect;
	private _sortFieldCombo: IconSelect;
	private _sortDirectionCombo: IconSelect;
	//private _acCombo: IconSelect;
	private _TType: SportType;
	private _statusSelect: Select;
	private _hideStat: CheckBox;
	private _hideCancelled: CheckBox;

	_initFields(settings: object)
	{
		this.EvFilterSortChanged = new Delegate();
		this._TType = SportType.MMA;
		super._initFields(settings);
	}

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="filter-panel"></div>');

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'Parameters',
			Class: 'app-list-group__subheader--accent'
		});

		this._tournamentCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Tournaments'),
			EvItemSelected: async () =>
			{
				await this.updateEvents();
				this._applyFiltersSort();
			}
		});

		this._eventCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Event'),
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._genderCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Gender'),
			SelectedIndex: 0,
			Items: [{
				Value: 'All',
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('All')
			}, {
				Value: 1,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('MaleGender')
			}, {
				Value: 0,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('FemaleGender')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._weightCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('WeightCategory'),
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._stageCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Stage'),
			EvItemSelected: () => this._applyFiltersSort()
		});

		// this._acCombo = new IconSelect({
		// 	ParentNode: this._root,
		// 	FloatingLabel: NP.RM.getString('Association'),
		// 	EvItemSelected: () => this._applyFiltersSort()
		// });

		this._statusSelect = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Status'),
			SelectedIndex: 0,
			Items: [
				{RK: 'All', Value: '', FontImage: NP.FontImages.list},
				{RK: 'NotStarted', Value: 'Not started', FontImage: NP.FontImages.list},
				{RK: 'InProgress', Value: 'In progress', FontImage: NP.FontImages.list},
				{RK: 'Finished', Value: 'Finished', FontImage: NP.FontImages.list},
				{RK: 'Canceled', Value: 'Canceled', FontImage: NP.FontImages.list},
				{RK: 'NoContest', Value: 'NoContest', FontImage: NP.FontImages.list}
			],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._hideStat = new CheckBox({
			ParentNode: this._root,
			RK: 'HideStat',
			Checked: true,
			EvCheckedChanged: () => this._applyFiltersSort()
		});

		this._hideCancelled = new CheckBox({
			ParentNode: this._root,
			RK: 'HideCancelled',
			Checked: true,
			EvCheckedChanged: () => this._applyFiltersSort()
		});

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'OrderBy',
			Class: 'app-list-group__subheader--accent'
		});

		this._sortFieldCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 5,
			Items: [{
				Value: 'Id',
				FontImage: NP.FontImages.sort,
				Content: 'Id'
			}, {
				Value: 'Red',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('Red')
			}, {
				Value: 'Blue',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('Blue')
			}, {
				Value: 'Stage',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByStage')
			}, {
				Value: 'Weight',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByWeight')
			}, {
				Value: 'Date',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByDate')
			}, {
				Value: 'Result',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('SortByResult')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._sortDirectionCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: -1,
				FontImage: NP.FontImages.arrow_downward,
				Content: NP.RM.getString('Desc')
			}, {
				Value: 1,
				FontImage: NP.FontImages.arrow_upward,
				Content: NP.RM.getString('Asc')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._renderItems([this._root], this._ParentNode || document.documentElement);
	}

	async loadFilters()
	{
		if (this._weightCombo)
		{
			let weights = await getWeights({Type: this._TType}) as Weight[],
				 items = weights.map(w => ({Value: w.Id, FontImage: NP.FontImages.weight, Content: getWeightString(w)})),
				 defaultItems = [{Value: null as any, FontImage: NP.FontImages.weight, Content: NP.RM.getString('All')}];
			this._weightCombo.clear();
			this._weightCombo.addItems(defaultItems);
			this._weightCombo.addItems(items);
			this._weightCombo.setSelectedIndex(0, false);
		}

		if (this._tournamentCombo)
		{
			let tournaments = await getTournaments(this._TType) as ITournament[],
				 items = tournaments.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name})),
				 defaultItems = [{
					 Value: null as any,
					 FontImage: NP.FontImages.event,
					 Content: NP.RM.getString('AllTournaments')
				 }];
			this._tournamentCombo.clear();
			this._tournamentCombo.addItems(defaultItems);
			this._tournamentCombo.addItems(items);
			this._tournamentCombo.setSelectedIndex(0, false);
		}

		this.updateEvents();

		if (this._stageCombo)
		{
			let stages = getStages() as string[],
				 items = stages.map(s => ({Value: s, FontImage: NP.FontImages.list, Content: s})),
				 defaultItems = [{Value: null as any, FontImage: NP.FontImages.list, Content: NP.RM.getString('All')}];
			this._stageCombo.clear();
			this._stageCombo.addItems(defaultItems);
			this._stageCombo.addItems(items);
			this._stageCombo.setSelectedIndex(0, false);
		}

		// if (this._acCombo)
		// {
		// 	let associations = await getAssociations() as string[]
		// 	this._acCombo.clear();
		// 	this._acCombo.addItems([{
		// 		Value: null as any, FontImage: NP.FontImages.list,
		// 		Content: NP.RM.getString('All')
		// 	} as ISelectItem, ...associations.map(s => ({Value: s, FontImage: NP.FontImages.list, Content: s}))]);
		// 	this._acCombo.setSelectedIndex(0, false);
		// }
	}

	private async updateEvents()
	{
		if (this._eventCombo && this._tournamentCombo?.getValue())
		{
			let response = await ServerAPI.callUiApi("/t-events", {
				TournamentId: this._tournamentCombo.getValue(),
				Count: 500
			}, 'POST') as { List: EventTournament[] };

			let items = response.List.map(s => ({Value: s, FontImage: NP.FontImages.event, Content: s.Name})),
				 defaultItems = [{Value: null as any, FontImage: NP.FontImages.event, Content: NP.RM.getString('All')}];


			this._eventCombo.clear();
			this._eventCombo.addItems(defaultItems);
			this._eventCombo.addItems(items);
			this._eventCombo.setSelectedIndex(0, false);
		}
	}

	_applyFiltersSort()
	{
		this.EvFilterSortChanged.fire(this, this.getFilterData())
	}

	getFilterData()
	{
		return {
			Sex: this._genderCombo.getValue() == 'All' ? null : this._genderCombo.getValue(),
			WeightCategory: this._weightCombo.getValue(),
			Stage: this._stageCombo.getValue(),
			SortField: this._sortFieldCombo.getValue(),
			SortDirection: this._sortDirectionCombo.getValue(),
			TournamentId: this._tournamentCombo.getValue(),
			EventId: this._eventCombo.getValue() && this._eventCombo.getValue().Id,
			JudgeId: null as number,
			//Association: this._acCombo.getValue(),
			Status: this._statusSelect.getValue(),
			HideStat: this._hideStat.getChecked(),
			HideCancelled: this._hideCancelled.getChecked()
		}
	}

	getSortValues()
	{
		return {
			SortField: this._sortFieldCombo.getValue(),
			SortDirection: this._sortDirectionCombo.getValue(),
		}
	}

	setSortValues(sortField: string, sortDirection: number)
	{
		this._sortFieldCombo.setValue(sortField, false);
		this._sortDirectionCombo.setValue(sortDirection, false);
	}
}
